/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReplyListContainerLocal = {
    readonly keyboardShortcutsConfig: {
        readonly key: string;
        readonly source: string;
        readonly reverse: boolean;
    } | null;
    readonly refreshStream: boolean | null;
    readonly " $refType": "ReplyListContainerLocal";
};
export type ReplyListContainerLocal$data = ReplyListContainerLocal;
export type ReplyListContainerLocal$key = {
    readonly " $data"?: ReplyListContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "KeyboardShortcutsConfig",
                    "kind": "LinkedField",
                    "name": "keyboardShortcutsConfig",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "key",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "source",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "reverse",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refreshStream",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '6a41d248f9a7d3ee11962bf088900bec';
export default node;
